import { Link } from "react-router-dom";
import { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";

import onfej from "../assets/ONFEJ_LOGO-01.jpg";
import logoPhone from "../assets/phone.png";
import logoEmail from "../assets/icons8-nouveau-message-48.png";
import * as constant from "../constants/constants";
import bgImageForHome from "../assets/children-2704878_1280.jpg";
import bgImageForContact from "../assets/GettyImages-1165078466.jpg";
import bgImageForTeam from "../assets/_DSC1984.jpg"; //meeting-business-936059_1280.jpg
import bgImageForAbout from '../assets/GettyImages-1165078466.jpg'
import bgImageForEvent from "../assets/_DSC2179.jpg"


const Header = (props) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const styliser =
    props.type === "home" ? "h-[63vh] bg-fixed" : "h-[60vh] bg-fixed";


  const home =
    props.type === "home" ? (
      <div className="animate__animated  animate__slideInUp animate__delay mx-4 md:mx-16 lg:mx-16 xl:mx-15">
        <div>
          <h1 className="pt-4 md:pt-10 lg:pt-14  text-[#ffa809] font-bold pb-[-14px]">
            Faire un don pour les enfants
          </h1 >
          <h2 className="pb-4 md:pb-6 pt-2 md:pt-8 text-white capitalize font-bold text-3xl  
           lg:w-[50%] md:w-[80%] sm:w-[100%]">
            Organisation Nationale pour la Formation
            et l'Épanouissement de la Jeunesse
          </h2>
        </div>
        <p className="text-white md:w-[400px] xl:w-[600px] lowercase">
          "L’ÉDUCATION EST L'ARME LA PLUS PUISSANTE
          POUR CHANGER LE MONDE."
        </p>
        <div className="bg-[#ffa809] w-[120px]  text-center font-bold text-white mt-8 md:mt-10">
          <Link
            to={constant.CONTACT}
            className="px-2.5 w-auto items-center py-2.5"
            type="submit"
          >
            Contact Us
          </Link>
        </div>
      </div>
    ) : props.type === "contact" ? (
      <div className="animate__animated  animate__slideInUp animate__delay text-center  text-white py-5 md:py-[4rem] lg:py-[5rem]">
        <h1 className="text-4xl  font-bold pb-5">
          Contact Us
        </h1>
        <p className="text-[16.7px]">
          Lorem ipsum tulum debe mele ele rele pele Lorem ipsum tulum debe mele
          ele rele pele
        </p>
        <p className="text-[16.7px]">
          Lorem ipsum tulum debe mele ele rele pele
        </p>
      </div>
    ) : props.type === "team" ? (
      <div className="animate__animated  animate__slideInUp animate__delay text-center text-white py-4 md:py-[4rem] lg:py-[5rem]">
        <h1 className="text-4xl font-bold py-4">
          Rencontrer notre equipe
        </h1>
        <p className="text-[16.7px]">
          Bienvenue dans notre communauté d'apprentissage et d'action.
        </p>
        <p className="text-[16.7px]">
          Lorem ipsum tulum debe mele ele rele pele
        </p>
      </div>
    ) : props.type === "about" ? (
      <div className="animate__animated  animate__slideInUp animate__delay text-center text-white py-5 md:py-[5rem] lg:py-[6rem] ">
        <h1 className="text-4xl font-bold pb-5">
          A propos de nous
        </h1>
        <p className="text-[16.7px]">
          Nous sommes une ONG dévouée à l'humanité, travaillant sans relâche pour résoudre des problèmes pressants.
        </p>
        <p className="text-[16.7px]">
          Notre mission est d'apporter un changement positif à grande échelle, une action à la fois.
          Rejoignez-nous dans cette quête altruiste.

        </p>
      </div>
    ) : (
      props.type === "event"
    ) ? (
      <div className="animate__animated  animate__slideInUp animate__delay text-center text-white py-5 md:py-[5rem] lg:py-[6rem]">
        <h1 className="text-4xl font-bold pb-5">
          Nos évenements
        </h1>
        <p className="text-[16.7px]">
          Découvrez notre section "Événements" et plongez dans un monde d'opportunités passionnantes.

        </p>
        <p className="text-[16.7px]">
          De conférences inspirantes à des ateliers éducatifs, nous vous invitons à explorer<br />
          notre programme dynamique et à vous joindre à nous pour des expériences<br />
          enrichissantes.
        </p>
      </div>
    ) : "default"

  const bgImg =
    props.type === "home"
      ? bgImageForHome
      : props.type === "contact"
        ? bgImageForContact
        : props.type === "event"
          ? bgImageForEvent
          : props.type === "team"
            ? bgImageForTeam
            : props.type === "about"
              ? bgImageForAbout
              : "default"


  return (
    <div className="mb-10">
      <div className="flex px-4 justify-end items-center h-10 bg-[#a0023b] text-[white]">
        <div className="flex justify-between items-center text-[13px]">
          <div className="flex items-center mr-7">
            <img src={logoEmail} alt="Icône e-mail" className="w-8 h-8 mr-2" />
            <p>
              <Link to="mailto:contactonfej@gmail.com">contactonfej@gmail.com</Link>
            </p>
          </div>

          <div className="flex items-center">
            <img
              src={logoPhone}
              alt="Icône téléphone"
              className="w-4 h-4 mr-2"
            />
            <p>
              <Link to="tel:+(509) 3873-3954 ">(509) 3873-3954 </Link>
            </p>
          </div>
        </div>
      </div>
      <div
        className={styliser}
        style={{
          background: `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${bgImg})`,
          backgroundSize: "cover",
          objectFit: "cover",
          backgroundAttachment: 'fixed'
        }}
      >
        <div className="flex justify-between px-4 md:px-16 pt-9">
          <div>
            <Link to="/">
              <img src={onfej} alt="err" width={60} height={60} />
            </Link>
          </div>
          <div className="hidden sm:flex">
            <nav>
              <ul className="text-white flex justify-center align-middle gap-6 font-bold ">
                <Link
                  to={`/${constant.HOME}`}
                  onClick={() => setMenuOpen(false)}
                >
                  Accueil
                </Link>
                <Link
                  to={`/${constant.ABOUT}`}
                  onClick={() => setMenuOpen(false)}
                >
                  A propos
                </Link>
                <Link
                  to={`/${constant.EVENT}`}
                  onClick={() => setMenuOpen(false)}
                >
                  Evenement
                </Link>
                <Link
                  to={`/${constant.TEAM}`}
                  onClick={() => setMenuOpen(false)}
                >
                  Equipe
                </Link>
                <Link
                  to={`/${constant.CONTACT}`}
                  onClick={() => setMenuOpen(false)}
                >
                  Contact
                </Link>
              </ul>
            </nav>
          </div>
          <div className="sm:hidden">
            <button onClick={toggleMenu} className="text-white">
              <FaBars />
            </button>
          </div>
        </div>
        {menuOpen && (
          <div
            className={`md:hidden fixed z-[1111] top-0 left-0 w-full h-full bg-[#a0023b] text-white flex flex-col items-center justify-center`}
          >
            <button
              onClick={closeMenu}
              className="text-white absolute top-[4rem] right-[2rem]"
            >
              <FaTimes size={20} className="text-white" />
            </button>
            <nav>
              <ul className="text-white flex flex-col gap-4 font-bold text-center">
                <Link to={`/${constant.HOME}`}>Accueil</Link>
                <Link to={`/${constant.ABOUT}`}>A propos</Link>
                <Link to={`/${constant.EVENT}`}>Evenement</Link>
                <Link to={`/${constant.TEAM}`}>Equipe</Link>
                <Link to={`/${constant.CONTACT}`}>Contact</Link>
              </ul>
            </nav>
          </div>
        )}
        {home}
      </div>
    </div>
  );
};

export default Header;